var React = require('react');

function Snapshot (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M365 95h-70.9l-15-40.3A15 15 0 00265 45H125a15 15 0 00-14 9.7L95.9 95H25a25 25 0 00-25 25v200a25 25 0 0025 25h340a25 25 0 0025-25V120a25 25 0 00-25-25zm-170 30a95.1 95.1 0 010 190 95.1 95.1 0 010-190z","key":0}),React.createElement("path",{"d":"M130 220a65 65 0 10130.1-.1 65 65 0 00-130.1.1z","key":1})]);
}

Snapshot.defaultProps = {"viewBox":"0 0 390 390"};

module.exports = Snapshot;

Snapshot.default = Snapshot;
